import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types'
import { FlowValveError } from '@/types/hydraulic'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchFlowValveError(
  interfaceId: number,
  searchParams: SearchParams = {},
): UseQueryResult<APIResponseList<FlowValveError>, any> {
  return useQuery(
    [queryKeys.flowValveError, interfaceId, searchParams],
    async () => {
      const { data } = await flowValveApi.getAll({
        ...searchParams,
        interfaceId,
      })

      // /api/flowvalve returns every valve; keep only the ones in error and
      // normalize `io` -> `pipeName` for the FlowValveTable.
      const errorList = (data?.data ?? [])
        .filter((item: any) => item.errorCode !== 0)
        .map((item: any) => ({
          ...item,
          pipeName: item.pipeName ?? item.io,
        }))

      return {
        list: errorList,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: errorList.length,
        totalPage: data.totalPage,
      }
    },
    {
      enabled: !!interfaceId, // Query chỉ chạy nếu interfaceId hợp lệ
      refetchInterval: 60000,
      placeholderData: {
        list: [],
        page: 1,
        size: 10,
        sort: null,
        totalCount: 0,
        totalPage: 0,
      },
    },
  )
}

export default useSearchFlowValveError
